import { frontendURL } from '../../../helper/URLHelper';
import OpsNoticesPage from 'dashboard/components-next/ops-notices/OpsNoticesPage.vue';

// Central de avisos — todo papel entra; o endpoint filtra o que cada um vê
// (admin: tudo; agente: só os avisos endereçados ao agente).
export const routes = [
  {
    path: frontendURL('accounts/:accountId/central'),
    name: 'ops_notices_index',
    component: OpsNoticesPage,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
